const UMR_OPI_TO_DELSYS = {
    58: '01',
    CORQ: '55',
    NXDW: '10112',
    NXDV: '10112',
    NXDU: '10112',
    NXDT: '10112',
    NXDS: '10112',
    NXDR: '10112',
    NXDP: '10112',
    NXDO: '10112',
    NXDN: '10112',
    NXDM: '10112',
    NXDJ: '10112',
    NXDH: '10112',
    NXDF: '10112',
    NXDE: '10112',
    NXDD: '10112',
    NXDC: '10112',
    NXDA: '10112',
    NXD1: '10112',
    NXCC: '10112',
    NXCB: '10112',
    NXCA: '10112',
    NXC9: '10112',
    NXC8: '10112',
    NXC7: '10112',
    NXC6: '10112',
    NXC5: '10112',
    NXC4: '10112',
    NXC3: '10112',
    NXC2: '10112',
    NXC1: '10112',
    NXBZ: '10112',
    NXBY: '10112',
    NXBX: '10112',
    NXBW: '10112',
    NXBV: '10112',
    NXBU: '10112',
    NXBT: '10112',
    NXBS: '10112',
    NXBR: '10112',
    NXBQ: '10112',
    NXB5: '10112',
    NXB4: '10112',
    NXB3: '10112',
    NXB2: '10112',
    NXDX: '10112',
    NXB1: '10112',
    NXAJ: '10112',
    NXAI: '10112',
    NXAH: '10112',
    NXAF: '10112',
    NXAE: '10112',
    NXAC: '10112',
    NXAA: '10112',
    NXA9: '10112',
    NXA8: '10112',
    NXA7: '10112',
    NXA6: '10112',
    NXA5: '10112',
    NXA3: '10112',
    NXA2: '10112',
    NXA1: '10112',
    NX1Z: '10112',
    NX1X: '10112',
    NX1W: '10112',
    NX1U: '10112',
    NX1T: '10112',
    NX1S: '10112',
    NX1Q: '10112',
    NX1P: '10112',
    NX1O: '10112',
    NX1N: '10112',
    NX1M: '10112',
    NX1L: '10112',
    NX1K: '10112',
    NX1J: '10112',
    NX1I: '10112',
    NX1H: '10112',
    NX1G: '10112',
    NX1F: '10112',
    NX1D: '10112',
    NX19: '10112',
    NX17: '10112',
    NX16: '10112',
    NX14: '10112',
    NX13: '10112',
    NX12: '10112',
    NX11: '10112',
    NX99: '10112',
    NX1C: '10112',
    NX98: '10112',
    NX1B: '10112',
    NX1A: '10112',
    NXDK: '10112',
    ZSEL: '46',
    SELN: '46',
    SECO: '46',
    '0LCR': '52',
    PFT: '52',
    '0LMP': '52',
    '1H0P': '52',
    '1HE1': '12710190',
    '1HNN': '12710191',
    '1HSN': '12710191',
    '1H6W': '52',
    '0LPL': '52',
    HPDC: '52',
    SELQ: '03',
    SELP: '03',
    SEL8: '03',
    SEL7: '03',
    SEL6: '03',
    SEL5: '03',
    SEL4: '03',
    SEL3: '03',
    SEL2: '03',
    SEL1: '03',
    HPDA: '52',
    P198: '10022',
    PD1: '52',
    SAP: '52',
    SPU: '01',
    '0LQR': '52',
    '0LQL': '52',
    '0LQB': '52',
    '0LQA': '52',
    PDSQ: '52',
    '0LQC': '52',
    HMPH: '52',
    HMDD: '52',
    OPT: '52',
    A: '51',
    WAL: '52',
    TRUL: '52',
    TRUO: '52',
    HDIG: '52',
    HDG2: '52',
    SUU: '01',
    HPSM: '52',
    HLPZ: '52',
    SEL: '03',
    PDA1: '52',
    P201: '10020',
    P197: '55',
    P193: '51',
    P192: '57',
    P190: '52',
    HFC2: '52',
    HFC1: '52',
    UOF: '52',
    '2H0N': '52',
    '2H0L': '52',
    '58SC': '01',
    PSAG: '52',
    POI1: '10169',
    PEDS: '10169',
    PEDR: '10169',
    PEDP: '10169',
    PEDN: '10169',
    PEDM: '10169',
    PEDH: '10169',
    PEDG: '10169',
    PEDF: '10169',
    PEDE: '10169',
    PEDC: '10169',
    PEDB: '10169',
    PED8: '10169',
    PED5: '10169',
    PED4: '10169',
    PED3: '10169',
    PED2: '10169',
    PED1: '10169',
    PECV: '10169',
    PECS: '10169',
    PECP: '10169',
    PECN: '10169',
    PECG: '10169',
    PECF: '10169',
    PECE: '10169',
    PECC: '10169',
    PECB: '10169',
    PECA: '10169',
    PEC8: '10169',
    PEC5: '10169',
    PEC4: '10169',
    PEC3: '10169',
    PEC2: '10169',
    PEC1: '10169',
    PEI3: '10169',
    PEI2: '10169',
    PEI1: '10169',
    PEDW: '10169',
    PEDV: '10169',
    PEDA: '10169',
    PED6: '10169',
    PECW: '10169',
    PECR: '10169',
    PECH: '10169',
    PECM: '10169',
    PEC6: '10169',
    HCCM: '52',
    CORS: '55',
    PDL: '52',
    '58EO': '01',
    '0LNC': '52',
    HWC: '52',
    ARHN: '52',
    HPV2: '52',
    HPV1: '52',
    HPVH: '52',
    ELP: '52',
    PDA2: '52',
    '0LR1': '52',
    HUH1: '52',
    GTE: '52',
    MGF: '52',
    NE0L: '52',
    PEXX: '10169',
    '1H0L': '52',
    '0LSG': '52',
    PDSA: '52',
    HTMC: '52',
    POPT: '01',
    POCH: '52',
    ELMB: '01',
    BE: '52',
    ACC: '52',
    '0LWM': '52',
    '0LS2': '52',
    PDP: '51',
    '58P': '10162',
    COR1: '10149',
    HWIL: '52',
    '0LSA': '52',
    '0LG': '52',
    '0LSB': '52',
    '0LWG': '52',
    PDS2: '52',
    MUK: '52',
    IMUK: '52',
    HAKU: '52',
    '0LP': '52',
    HLOS: '52',
    SELA: '10161',
    '0LSC': '52',
    '0LNP': '52',
    '0LA': '10145',
    QR: '10145',
    COR2: '55',
    COR: '55',
    '0LUC': '52',
    QR8: '10145',
    '0LR': '52',
    '58R': '01',
    TPD: '52',
    PDWG: '52',
    '0LA1': '52',
    HDG3: '52',
    TB: '01',
    SA: '01',
    HSVM: '01',
    WR: '52',
    WASH: '52',
    UPST: '52',
    QB: '52',
    QA: '52',
    P4: '52',
    MIAM: '52',
    LEN: '52',
    HSFH: '52',
    HPNX: '52',
    HNAH: '52',
    HNAE: '52',
    GBAY: '52',
    ELM: '52',
    CRI: '52',
    ADVN: '52',
    AAY: '52',
    '0LHC': '52',
    '0LRL': '52',
    '0LM2': '52',
    '0LM1': '52',
    TC: '52',
    RIC: '52',
    PBCF: '52',
    '0LAL': '52',
    BK: '01',
    '0L': '52',
    VM: '52',
    GK: '52',
    P3: '52',
};

module.exports = {
    UMR_OPI_TO_DELSYS,
};
